@use '../../../scss/utility';

:host {
  display: block;
}

:host([tag='span']),
:host([tag='b']),
:host([tag='em']),
:host([tag='i']),
:host([tag='strong']),
:host([tag='small']) {
  display: inline;
}

.tag {
  @include utility.wb-type-normalizing;
  font: inherit;
  box-shadow: border-box;
  margin: 0;
}

:host([ellipsis]) {
  overflow: hidden;

  .tag {
    overflow: hidden;
    text-overflow: ellipsis;
  }
}

@each $size in ('xl', 'l', 'm', 's', 'xs') {
  :host([size='#{$size}']:not([chinese])) {
    @include utility.wb-heading(
      $size,
      (
        includeSupStyles: false,
        includeSubStyles: false,
        includeNormalizations: false,
      )
    );
  }

  :host([size='#{$size}'][chinese]) {
    @include utility.wb-heading(
      $size,
      (
        chinese: true,
        includeSupStyles: false,
        includeSubStyles: false,
        includeNormalizations: false,
      )
    );
  }

  :host([size='#{$size}'][line-height-increased]) {
    @include utility.wb-heading(
      $size,
      (
        line-height-increased: true,
        includeSupStyles: false,
        includeSubStyles: false,
        includeNormalizations: false,
      )
    );
  }
}

::slotted(sup) {
  @include utility.wb-superscript;
  position: relative;
  inset-block-end: 0.5em;
}

::slotted(sub) {
  @include utility.wb-subscript;
}
